import { ApiLinkEntity, ApiLinkRel, FileType } from "config/constants"
import { IApiLink, IMultipleEntitiesResponse } from "@/types"
import InvoiceImportItem, { IGetInvoiceImportItemDto } from "./InvoiceImportItem"

export const INVOICE_IMPORT_TEMPLATE_URL = "/files/Invoice-Import.xlsx"
export const INVOICE_IMPORT_MAX_SIZE_MB = 5
export const INVOICE_IMPORT_EXTENSIONS = [".xlsx"]
export const INVOICE_IMPORT_TYPES = [FileType.msOffice]
export const INVOICE_IMPORT_INPUT_FILE_ACCEPT = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"]
export const INVOICE_IMPORT_ROWS_LIMIT = 1000

export enum InvoiceImportOperationStatus {
    idle = "idle",
    validation = "validation",
    invalid = "invalid",
    importing = "importing",
    incomplete = "incomplete",
    complete = "complete"
}

export enum InvoiceImportError {
    contentType = "ContentType",
    size = "Size",
    rowsLimit = "RowsLimit",
    template = "Template",
    data=  "Data",
}

export enum InvoiceImportType {
    excel = "excel",
    erp = "erp",
}

export interface IGetInvoiceImportOperationDto extends IMultipleEntitiesResponse<IGetInvoiceImportItemDto> {
    status: InvoiceImportOperationStatus
    invoiceImportType?: InvoiceImportType
    erpInvoicesQuantity: number
}

export default class InvoiceImportOperation {
    items: InvoiceImportItem[]
    status: InvoiceImportOperationStatus
    invoiceImportType?: InvoiceImportType
    erpInvoicesQuantity: number
    linkInvoiceImportSetupExcel?: IApiLink
    linkInvoiceImportSetupErp?: IApiLink
    linkInvoiceImportOperationClose?: IApiLink
    linkDeleteInvoiceImportItems?: IApiLink
    linkImportInvoiceImportItems?: IApiLink
    linkManualCreateInvoice?: IApiLink

    constructor(dto: IGetInvoiceImportOperationDto) {
        this.items = dto.entities.map((item, idx) => new InvoiceImportItem(item, idx + 1))
        this.status = dto.status
        this.invoiceImportType = dto.invoiceImportType
        this.erpInvoicesQuantity = dto.erpInvoicesQuantity
        this.linkInvoiceImportSetupExcel = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.invoiceExcelImportOperation && lnk.rel === ApiLinkRel.new)
        this.linkInvoiceImportSetupErp = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.invoiceErpImportOperation && lnk.rel === ApiLinkRel.new)
        this.linkInvoiceImportOperationClose = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.invoiceImportOperation && lnk.rel === ApiLinkRel.delete)
        this.linkDeleteInvoiceImportItems = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.invoiceImportItem && lnk.rel === ApiLinkRel.delete)
        this.linkImportInvoiceImportItems = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.invoiceImportItem && lnk.rel === ApiLinkRel.new)
        this.linkManualCreateInvoice = dto.links?.find(lnk => lnk.entity === ApiLinkEntity.invoice && lnk.rel === ApiLinkRel.new)
    }
}
